// Adapted from analytics.js-loader
// https://github.com/vvo/analytics.js-loader/blob/master/index.js

export default function load(opts) {
  // Create a queue, but don't obliterate an existing one!
  // Stripe prevents loading itself over itself
  var stripeLoader = global.stripeLoader = global.stripeLoader || [];

  // If the real stripeLoader.js is already on the page return.
  if (stripeLoader.activate) return;

  // If the snippet was invoked already show an error.
  if (stripeLoader.invoked) {
    if (window.console && console.error) {
      console.error('stripeLoader snippet included twice.');
    }
    return;
  }


  // Invoked flag, to make sure the snippet
  // is never invoked twice.
  stripeLoader.invoked = true;

  // Define a method to load stripeLoader.js from our CDN,
  // and that will be sure to only ever load it once.
  stripeLoader.load = function (key) {
    var $script = require("scriptjs");
    $script("https://js.stripe.com/v2/", function () {
      Stripe.setPublishableKey(key);
    });
  };

  // Load stripeLoader.js with your key, which will automatically
  // load the tools you've enabled for your account. Boosh!
  stripeLoader.load(opts.writeKey);
}



// WEBPACK FOOTER //
// ./custom_modules/stripe-loader/index.js